import { html } from 'fxjs/es';
import { makeExpandableContainer } from '../../../Product/Detail/S/tmpl.js';
// bp['product_info' + _en] && bp['product_info' + _en].length
/* {product_info, brand_logo, brand_name, brand_description }, */
const bpBrandInfo = ({ brand_logo, brand_name, brand_description }) => html`
  <div class="brand">
    <div class="brand_logo"></div>
    <img src="${G.to_150(brand_logo)}" alt="${brand_name}" />
    <div class="brand_name_en">${brand_name}</div>
    <div class="brand_description_en">${brand_description}</div>
  </div>
`;

export const bpInfo = ({ brand_logo, brand_name, brand_description, product_info, is_mobile }) => html`
  <div class="toggle_cont toggle_cont_img product_info" is_open="true">
    ${makeExpandableContainer({
      title: T('product_detail::Product Info'),
      body: html`<div class="tg_head">${makeTgHead(T('product_detail::Product Info'))}</div>
        <div class="tg_body">
          <div class="product_info_text">${product_info}</div>
          <div class="product_info_text product_info_text--precautions">
            <p><strong>${T('product_detail::precautions')}</strong></p>
            <ul>
              <li>${T('product_detail::precautions_info')}</li>
            </ul>
          </div>
          ${brand_logo && brand_name && brand_description
            ? bpBrandInfo({ brand_logo, brand_name, brand_description })
            : ''}
        </div>`,
      disabled: !is_mobile,
    })}
  </div>
`;

export function makeTgHead(title) {
  return html`
    ${G.collabo_type === ''
      ? html` <h3 class="tit">${title}</h3> `
      : html` <span class="tit">${title}</span> `}
  `;
}
